import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Notifications } from '../interfaces/notification.interface';

@Injectable({
  providedIn: 'root'
})
export class NotificationsStateService {
  private newNotificationSubject = new BehaviorSubject<boolean>(false);
  private notificationsSubject = new BehaviorSubject<Notifications[]>([]);

  newNotification$ = this.newNotificationSubject.asObservable();
  notifications$ = this.notificationsSubject.asObservable();

  constructor() {}

  setNewNotification(status: boolean): void {
    this.newNotificationSubject.next(status);
  }

  setNotifications(notifications: Notifications[]): void {
    this.notificationsSubject.next(notifications);
    this.checkForUnreadNotifications(notifications);
  }

  private checkForUnreadNotifications(notifications: Notifications[]): void {
    const hasUnread = notifications.some((notification) => !notification.leida);
    this.setNewNotification(hasUnread);
  }
}
